import * as React from 'react';

const SvgEyePasswordHide = (props) => (
  <svg
    width={16}
    height={16}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#EyePasswordHide_svg__a)' fill='#333132'>
      <path d='M9.687 10.187a.495.495 0 0 0 .353-.147A2.87 2.87 0 0 0 10.887 8 2.888 2.888 0 0 0 8 5.113c-.767 0-1.493.3-2.04.847a.5.5 0 0 0 0 .707l3.373 3.373c.1.1.227.147.354.147ZM8 6.113a1.89 1.89 0 0 1 1.64 2.82L7.067 6.36c.28-.16.6-.247.933-.247Z' />
      <path d='M12.267 12.34c.113 0 .233-.04.326-.12a9.673 9.673 0 0 0 1.9-2.22c.707-1.1.707-2.893 0-4C12.867 3.453 10.5 1.987 8 1.987c-1.467 0-2.913.506-4.18 1.46a.5.5 0 0 0 .6.8C5.513 3.42 6.753 2.987 8 2.987c2.153 0 4.213 1.293 5.653 3.553.5.78.5 2.14 0 2.92a9.155 9.155 0 0 1-1.706 2 .504.504 0 0 0-.054.707.484.484 0 0 0 .374.173ZM7.998 14.013c.887 0 1.754-.18 2.587-.533a.5.5 0 0 0-.387-.92c-.706.3-1.446.453-2.193.453-2.153 0-4.213-1.293-5.653-3.553-.5-.78-.5-2.14 0-2.92.206-.327.433-.64.673-.933a.506.506 0 0 0-.073-.707.5.5 0 0 0-.707.073c-.26.32-.513.667-.74 1.027-.707 1.1-.707 2.893 0 4 1.627 2.547 3.993 4.013 6.493 4.013Z' />
      <path d='M7.54 10.847a.505.505 0 0 0 .494-.407.49.49 0 0 0-.4-.58 1.88 1.88 0 0 1-1.48-1.48.506.506 0 0 0-.587-.4.5.5 0 0 0-.4.587 2.865 2.865 0 0 0 2.28 2.28c.033-.007.06 0 .093 0ZM14.666 15.167a.495.495 0 0 0 .353-.147.503.503 0 0 0 0-.707l-4.98-4.98a.503.503 0 0 0-.707 0 .503.503 0 0 0 0 .707l4.98 4.98c.1.1.227.147.354.147ZM6.314 6.813a.494.494 0 0 0 .354-.146.503.503 0 0 0 0-.707L1.688.98a.503.503 0 0 0-.707 0 .503.503 0 0 0 0 .707l4.98 4.98c.1.1.226.146.353.146Z' />
    </g>
    <defs>
      <clipPath id='EyePasswordHide_svg__a'>
        <path fill='#fff' transform='matrix(-1 0 0 1 16 0)' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEyePasswordHide;
